import { amber, green } from '@mui/material/colors';
import { styled } from '@mui/material/styles';

export const MessageRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  '&.success': {
    backgroundColor: green[600]
  },
  '&.error': {
    backgroundColor: theme.palette.error.dark
  },
  '&.info': {
    backgroundColor: theme.palette.primary.dark
  },
  '&.warning': {
    backgroundColor: amber[700]
  }
}));

export const Icon = styled('span')(({ theme }) => ({
  fontSize: 20,

  '&.iconVariant': {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  }
}));
